import { FC } from "react";
import { Box, Typography } from "@mui/material";
import __ from "src/utils/Translations";

interface ITitleProps {
  title: string;
  subtitle?: string;
}

const Title: FC<ITitleProps> = ({ title, subtitle }) => (
  <Box sx={{ m: "2rem 0" }}>
    <Typography variant="h4" component="h1">
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body1" mt="0.5rem">
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default Title;
